import { ref, computed, unref } from "vue";
import axios from "axios";
import { API_URL } from "@/utils/constans";
import { useSertStore } from "@/stores/sertStore";


const isClient = typeof window !== "undefined";

export const token = ref(null);

if (isClient) {
    token.value = sessionStorage.getItem("session_token");
}

const setToken = (newToken) => {
    token.value = newToken;
    sessionStorage.setItem("session_token", newToken);
};

export const removeToken = () => {
    token.value = null;
    sessionStorage.removeItem("session_token");
};

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            removeToken();
            delete axios.defaults.headers.common["Authorization"];
        }
        return Promise.reject(error);
    }
);

export const getCertificate = async (params, isNew = false) => {
    const parameters = unref(params);
    const storeSert = useSertStore();
    try {
        if (isNew) {
            const { data } = await axios.post(
                `${API_URL}/api/certificates/certificate`,
                parameters
            );
            setToken(data.session_token);
            console.log("POST сертификата");

            storeSert.setOriginalCertificateParams(parameters);
        } else {
            await axios.put(`${API_URL}/api/certificates/certificate`, parameters);
            console.log("PUT сертификата");

            storeSert.setOriginalCertificateParams(parameters);
        }
    } catch (error) {
        console.log("getCertificate error:", error);
    }
};

export const getPaymentUrl = async (parameters) => {
    parameters = { ...parameters, session_token: token.value };

    const response = await axios.post(`${API_URL}/api/certificates/certificate/pay`, parameters);

    return response;
};

export const checkedStatusCert = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/certificates/certificate`, {
            params: {
                session_token: token.value,
            },
        });
        return response;
    } catch (error) {
        console.log("checkedStatusCert:", error);
    } finally {
    }
};

export const getListCovers = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/certificates/covers?limit=100`);
        return response?.data.results;
    } catch (error) {
        console.log("getListCovers:", error);
    } finally {
    }
};
export const getListMessages = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/certificates/popular-messages?limit=100`);
        return response?.data.results;
    } catch (error) {
        console.log("getListCovers:", error);
    } finally {
    }
};
export const getListPrices = async () => {
    try {
        const response = await axios.get(
            `${API_URL}/api/certificates/certificate/prices?limit=100`
        );
        return response?.data.results;
    } catch (error) {
        console.log("getListCovers:", error);
    } finally {
    }
};

export const createUser = async (parameters) => {
    parameters = { ...parameters, session_token: token.value };
    try {
        const response = await axios.post(`${API_URL}/api/users/user`, parameters);
    } catch (error) {
        console.log("createUser:", error);
    } finally {
    }
};
export const changeUser = async (parameters) => {
    parameters = { ...parameters, session_token: token.value };
    try {
        const response = await axios.put(`${API_URL}/api/users/user`, parameters);
    } catch (error) {
        console.log("changeUser:", error);
    } finally {
    }
};

export const verificationNumberPhone = async (parameters) => {
    parameters = { ...parameters, session_token: token.value };

    const response = await axios.post(`${API_URL}/api/users/verify-phone-number`, parameters);

    return response;
};
export const verificationCodeSms = async (parameters) => {
    parameters = { ...parameters, session_token: token.value };

    const response = await axios.post(`${API_URL}/api/users/verify-sms`, parameters);

    return response;
};

export const getFaq = async () => {
    try {
        const { data } = await axios.get(`${API_URL}/api/feedback/faq?sites=1&limit=50`);
        return data.results;
    } catch (error) {
        console.log("getFaq:", error);
    }
};
